export const SCHEMA_VERSION = "d3747f2384da74579b44b2de0cb7c42b";